import React, {FC} from 'react';

import useStyles from './styles';

export const Layout: FC = ({children}) => {
  const classes = useStyles();
  return <div className={classes.layout}>{children}</div>;
};
